import { BCMSRecord, BCMSRecordProperty } from "@bcm-dev/bcms-vite";

/**
* @class Institution
* @classdesc Class definition for record type from model
* @param {OBJECT} record - record from model to init class
* @extends BCMSRecord
* @example const record = model.institutions[0];
* const contactInfo = new Institution(record);
* @property {NUMBER} _id - The id of the Institution.
*/
export default class Institution extends BCMSRecord {
    _id
    _name
    _routingNumber

    constructor (record){     
      super(record) 
    }
  }

  Institution.define({
    "recordType": "institutions",
    "recordIDProp": "id",
    "className" : "Institution",
    "recordProperties":[
      /** 
       * @name id
       * @instance
       * @property get {NUMBER} - gets the id value
       * @property set {NUMBER} - sets the id value
       * @memberof Institution
       */
      BCMSRecordProperty.mapToNumber("id","_id"),

      /** 
       * @name name
       * @instance
       * @property get {STRING} - gets the name value
       * @property set {STRING} - sets the name value
       * @memberof Institution
       */
      BCMSRecordProperty.mapToString("name", "_name"),

       /** 
       * @name routingNumber
       * @instance
       * @property get {STRING} - gets the routingNumber value
       * @property set {STRING} - sets the routingNumber value
       * @memberof Institution
       */
       BCMSRecordProperty.mapToString("routingNumber", "_routingNumber"),
    ]  
})




